import RequestAPI from '@/apis/request';
import BranchAPI from '@/apis/branch/branchAPI';
import store from '@/stores/store';
import registersService from '@/apis/registers/registersAPI';
import LicenseTicketApi from '@/apis/tickets';
import PartnerApi from '@/apis/partner';
import AccountApi from '@/apis/accounts/accountAPI'

class MiddleWare {
  /**
   * validate trước khi vào trang tạo request
   * hvmanh 27.9.2023
   * @param {*} to
   * @param {*} from
   * @param {*} next
   */
  async validIdMiddleWare(to, from, next) {
    try {
      const id = to.params.id;
      to.meta.roles = true; // role o day check partner
      const data = await RequestAPI.getDetailRequest(id);
      to.meta.data = data.Data;
      // lấy thông tin các gói p
      const packageResult = await store.dispatch('globalcontext/getPackages');
      to.meta.packages = packageResult?.Data?.map((item) => {
        return {
          PackID: item.package_id,
          ProductPackCode: item.package_code,
          PackName: item.package_name,
          PricePerMonth: item.price_per_month,
          PricePerYear: item.price_per_year,
          FeeInitial: item.fee_initial,
          ExtraPos: item.extra_pos,
          ExtraTablet: item.extra_tablet,
          NumberOfPOS: item.number_of_pos,
          NumberOfTablet: item.number_of_tablet,
          NumberOfHandheld: item.number_of_handheld,
          National: item.national,
          ExtraKiosk: item.extra_kiosk,
          PartnerCode: item.partner_code
        };
      });

      if (data?.Data?.company_code) {
      //   // lay thong tin share_rate theo doi tac
      //   let partner = await PartnerApi.getListPartnerPaging({
      //     skip: 0,
      //     take: -1,
      //     sort: '',
      //     filter: JSON.stringify([
      //       {
      //         Field: 'partner_name',
      //         Operator: '=',
      //         Value: data?.Data?.religion,
      //       },
      //     ]),
      //     emptyFilter: '',
      //     columns: 'purchase_new_rate',
      //   });

      //   if (partner?.Data && partner?.Data?.Data && partner?.Data?.Data[0]) {
      //     // to.meta.data.share_rate = partner?.Data?.Data[0].share_rate || 0;
      //     // to.meta.data.partner_id = partner?.Data?.Data[0].partner_id;
      //   }

        // lấy thông tin thiết bị — từ branch (current-state hub) qua Proc_GetLicenseInfo
        // Created by: lvduy — 14/09/2026 (thay /number-device)
        let result = await BranchAPI.getLicenseInfo(
          data?.Data?.company_code,
          data?.Data?.branch_id
        );

        to.meta.data.number_pos_display = result?.Data?.number_of_pos || 0;
        to.meta.data.number_tablet_display = result?.Data?.number_of_tablet || 0;
        to.meta.data.number_kiosk_display = result?.Data?.number_of_kiosk || 0;

        // lấy thông tin request gần nhất để thực hiện lấy exchange_rate
        let res = await RequestAPI.nearestRequest();
        to.meta.data.exchange_rate = res?.Data?.exchange_rate;
        to.meta.data.promotion = res?.Data?.promotion;
        if (data?.Data?.package_id == 1 && data?.Data?.ticket_id > 0) {
          let resTicket = await LicenseTicketApi.getDetailTicket(
            data?.Data?.ticket_id
          );

          to.meta.data.agent_number_pos = resTicket?.Data?.number_pos;
          to.meta.data.agent_number_tablet = resTicket?.Data?.number_tablet;
          to.meta.data.agent_note = resTicket?.Data?.note;
          to.meta.data.ticket_package_id = resTicket?.Data?.package_id;
        }
        // Lấy thông tin partner
        let partner = await PartnerApi.getEdit({id: data?.Data?.partner_id });
        if (partner && partner.Data) {
          to.meta.partner = partner.Data;
        }
        next();
      } else {
        next('/notfound');
      }
    } catch {
      next('/500');
    }
  }

  async validIdMiddleWareEditPage(to, from, next) {
    try {
      const id = to.params.id;
      to.meta.roles = true; // role o day check partner
      const data = await RequestAPI.getDetailRequest(id);
      to.meta.data = data.Data;
      // lưu tên page trước đó
      to.meta.data.beforeName = from.name;
     
      if(data.Data.modified_employee_id) {
        let resEmployee =  await AccountApi.getAccountPagging({
          skip: 0,
          take: 1,
          sort: '',
          filter: JSON.stringify([
            {
              Field: 'employee_id',
              Operator: '=',
              Value: data.Data.modified_employee_id,
            },
          ]),
          emptyFilter: '',
          columns: 'employee_id',
        });

        if(!resEmployee.Data?.Data?.length){
          to.meta.data.modified_by = '';
        }
      }else {
        to.meta.data.modified_by = ""
      }

      //lấy thông tin các gói
      const packageResult = await store.dispatch('globalcontext/getPackages');
      to.meta.packages = packageResult?.Data?.map((item) => {
        return {
          PackID: item.package_id,
          ProductPackCode: item.package_code,
          PackName: item.package_name,
          PricePerMonth: item.price_per_month,
          PricePerYear: item.price_per_year,
          FeeInitial: item.fee_initial,
          ExtraPos: item.extra_pos,
          ExtraTablet: item.extra_tablet,
          NumberOfPOS: item.number_of_pos,
          NumberOfTablet: item.number_of_tablet,
          NumberOfHandheld: item.number_of_handheld,
          National: item.national,
          ExtraKiosk: item.extra_kiosk,
          PartnerCode: item.partner_code
        };
      });

      if (data?.Data?.company_code) {   
        // lay thong tin cua license hien thi cho phan license info
        let license = await RequestAPI.getDetailRequestCompanyCode(
          data?.Data?.company_code
        );
        to.meta.licenseInfo = license?.Data && license?.Data;
        // lấy số lượng thiết bị hiển thị — từ branch (current-state hub) qua Proc_GetLicenseInfo
        // Created by: lvduy — 14/09/2026 (thay /number-device)
        let result = await BranchAPI.getLicenseInfo(
          data?.Data?.company_code,
          data?.Data?.branch_id
        );
        to.meta.data.number_pos_display = result?.Data?.number_of_pos || 0;
        to.meta.data.number_tablet_display = result?.Data?.number_of_tablet || 0;
        to.meta.data.number_kiosk_display = result?.Data?.number_of_kiosk || 0;
        next();
      } else {
        next('/notfound');
      }
    } catch (ex) {
      next('/500');
    }
  }

  async CheckActiveLink(to, from, next) {
    const companycode = to.params.companycode;
    const activeLink = `${window.origin}${to.fullPath}`;

    const result = await registersService.checkActiveLink({
      companyCode: companycode,
      activeLink: activeLink,
    });
    const data = result.Data;
    if (data) {
      next();
    } else {
      next('/notfound');
    }
  }

  /**
   * Validate route /request/detail (page tự fetch data, middleware chỉ validate params)
   * mode khác create thì bắt buộc có requestId trên query, thiếu → /500
   * Created by: lvduy
   * Created date: 2026-09-14
   */
  validRequestDetailMiddleware(to, from, next) {
    const mode = to.query?.mode || 'view';
    if (mode !== 'create' && !to.query?.requestId) {
      next('/500');
      return;
    }
    next();
  }

  /**
   * Load packages middleware cho CreateLicenseDetail page
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async loadPackagesMiddleware(to, from, next) {
    try {
      // Lấy thông tin các gói package
      const packageResult = await store.dispatch('globalcontext/getPackages');
      to.meta.packages = packageResult?.Data?.map((item) => {
        return {
          PackID: item.package_id,
          ProductPackCode: item.package_code,
          PackName: item.package_name,
          PricePerMonth: item.price_per_month,
          PricePerYear: item.price_per_year,
          FeeInitial: item.fee_initial,
          ExtraPos: item.extra_pos,
          ExtraTablet: item.extra_tablet,
          NumberOfPOS: item.number_of_pos,
          NumberOfTablet: item.number_of_tablet,
          NumberOfHandheld: item.number_of_handheld,
          National: item.national,
          ExtraKiosk: item.extra_kiosk,
          PartnerCode: item.partner_code
        };
      });
      
      next();
    } catch (ex) {
      console.error('Error loading packages:', ex);
      next('/500');
    }
  }

  /**
   * Middleware để load parent-child requests cho flow request new branch
   * Created by: hbviet
   * Created date: 14/07/2025
   * @param {*} to
   * @param {*} from  
   * @param {*} next
   */
  async validParentChildRequestMiddleware(to, from, next) {
    try {
      const id = to.params.id;
      to.meta.roles = true;
      
      // Load parent request detail
      const parentData = await RequestAPI.getDetailRequest(id);
      to.meta.data = parentData.Data;
      
      // Load child requests
      const childrenData = await RequestAPI.getRequestChildren(id);
      to.meta.childRequests = childrenData.Data || [];
      
      // Load packages
      const packageResult = await store.dispatch('globalcontext/getPackages');
      to.meta.packages = packageResult?.Data?.map((item) => {
        return {
          PackID: item.package_id,
          ProductPackCode: item.package_code,
          PackName: item.package_name,
          PricePerMonth: item.price_per_month,
          PricePerYear: item.price_per_year,
          FeeInitial: item.fee_initial,
          ExtraPos: item.extra_pos,
          ExtraTablet: item.extra_tablet,
          NumberOfPOS: item.number_of_pos,
          NumberOfTablet: item.number_of_tablet,
          NumberOfHandheld: item.number_of_handheld,
          National: item.national,
          ExtraKiosk: item.extra_kiosk,
          PartnerCode: item.partner_code
        };
      });

      // Load partner info if needed
      if (parentData?.Data?.company_code) {
        // let partner = await PartnerApi.getListPartnerPaging({
        //   skip: 0,
        //   take: -1,
        //   sort: '',
        //   filter: JSON.stringify([
        //     {
        //       Field: 'partner_name',
        //       Operator: '=',
        //       Value: parentData?.Data?.religion,
        //     },
        //   ]),
        //   emptyFilter: '',
        //   columns: 'purchase_new_rate',
        // });

        // if (partner?.Data && partner?.Data?.Data && partner?.Data?.Data[0]) {
        //   to.meta.data.share_rate = partner?.Data?.Data[0].purchase_new_rate || 0;
        // }
        let partner = await PartnerApi.getEdit({id: parentData?.Data?.partner_id });
        if (partner && partner.Data) {
          to.meta.partner = partner.Data;
        }
      }
      
      next();
    } catch (ex) {
      console.error('Error loading parent-child requests:', ex);
      next('/500');
    }
  }
}

export default new MiddleWare();
